import axios from 'axios';

const adminApi = axios.create({
    baseURL: process.env.MIX_ADMIN_API_URL,
    timeout: 30000,
});

export default adminApi;